// ** React Imports
import React from 'react'

// ** MUI Imports
import { Button, Grid, Typography } from '@mui/material'

// ** Child Imports
import AnalyticsDataWidget from '../visualizations/AnalyticsDataWidget'

// ** Util Imports
import { WidgetType } from 'src/lib/types/dashboardAnalytics'
import { 
    initialOrdersWidgetData, 
    C2PWidgetConfig, 
    initialC2PConversionWidgetData} from 'src/assets/AnalyticsConfig'
import { useMerchant } from 'src/lib/contexts/MerchantContext'
import { setMerchantAttributes } from 'src/lib/core/api-methods'
import { useLoader } from 'src/lib/contexts/LoaderContext'
import { numberWithCommas } from 'src/lib/utils/helpers'

const PrefilledAddressWidget: React.FC<WidgetType> = ({ 
    value,
    isLoading
}) => {
    const defaultValue = initialC2PConversionWidgetData?.data?.widgetData;
    const finalValue = value ?? defaultValue;
   
    return (
        <>
            <Grid container width={"100%"}>
                <AnalyticsDataWidget
                    removeInnerPadding
                    widgetType={"summary"} 
                    valueType={"percentage"} 
                    description={`${numberWithCommas(finalValue?.[2]?.x, 0)} out of ${numberWithCommas(finalValue?.[1]?.x, 0)} logins`}
                    widgetWidth={"100%"}
                    fontProperties={{
                        fontSize: 28,
                        fontWeight: 600,
                        fontColor: "#4D4D4D",
                        lineHeight: '36px'
                    }}
                    value={finalValue?.[0]?.x ?? "0"}
                    isLoading={isLoading}
                    hideBorders
                    cardVariant='outlined'
                />
            </Grid>
        </>
  )
}

export default PrefilledAddressWidget

            